export const fonts = {
  opensans: '"OpenSans", sans-serif'
};
